module.exports = __webpack_public_path__ + "static/media/o2Pop.79aaaec6.mp3";